<template>
  <div class="system">
    <TabsHead active-tab="system"> </TabsHead>
    <Card class="system-card" shadow>
      <Row :gutter="20">
        <i-col span="6">
          <div class="info-card version">
            <p class="card-title">{{ $t('common.version') }}</p>
            <p class="card-content">{{ systemInfo.version }}</p>
          </div>
        </i-col>
        <i-col span="6">
          <div class="info-card os">
            <p class="card-title">{{ $t('system.os') }}</p>
            <p class="card-content">{{ systemInfo.os }}</p>
          </div>
        </i-col>
        <i-col span="6">
          <div class="info-card arch">
            <p class="card-title">{{ $t('system.arch') }}</p>
            <p class="card-content">{{ systemInfo.arch }}</p>
          </div>
        </i-col>
        <i-col span="6">
          <div class="info-card time">
            <p class="card-title">{{ $t('system.uptime') }}</p>
            <p class="card-content">{{ systemInfo.upTimeSeconds }}</p>
          </div>
        </i-col>
      </Row>
    </Card>
  </div>
</template>

<script>
import TabsHead from '@/components/TabsHead'
import nodeID from '@/mixins/nodeID'
import { loadSystemInfo } from '@/api/system'
import { getTime } from '@/utils/time'

export default {
  name: 'System',

  components: {
    TabsHead,
  },

  mixins: [nodeID],

  data() {
    return {
      systemInfo: {},
      timer: null,
    }
  },

  created() {
    this.loadData()
  },

  beforeDestroy() {
    clearTimeout(this.timer)
  },

  beforeRouteLeave(to, from, next) {
    clearTimeout(this.timer)
    next()
  },

  methods: {
    setLoadInfoInterval() {
      this.timer = setTimeout(() => {
        this.loadData()
      }, 1000)
    },
    loadData() {
      loadSystemInfo(this.nodeID).then((res) => {
        this.systemInfo = res.data
        const { upTimeSeconds, os } = this.systemInfo
        this.systemInfo.os = this.fistLetterUpper(os)
        this.systemInfo.upTimeSeconds = this.parseUpTime(upTimeSeconds)
        this.setLoadInfoInterval()
      })
    },
    parseUpTime(val) {
      if (val) {
        const [day, hours, mins, seconds] = getTime(val)
        let timeStr = `${mins} ${this.$t('common.min', mins)}, ${seconds} ${this.$t('common.seconds', seconds)}`
        if (hours !== 0) {
          timeStr = `${hours} ${this.$t('common.hour', hours)}, ${timeStr}`
        }
        if (day !== 0) {
          timeStr = `${day} ${this.$t('common.day', day)}, ${timeStr}`
        }
        return timeStr
      }
      return val
    },
    fistLetterUpper(val) {
      return val ? val.charAt(0).toUpperCase() + val.slice(1) : val
    },
  },
}
</script>

<style lang="scss">
.system {
  position: relative;
  .system-card {
    border-radius: 8px;
  }
  .info-card {
    border-radius: 8px;
    text-align: center;
    padding: 16px 0;
    .card-title {
      color: #e4e4e4;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .card-content {
      color: #ffffff;
      font-size: 16px;
      font-weight: 500;
    }
    &.version {
      background: linear-gradient(314deg, #21a950 0%, #00b173 100%);
    }
    &.os {
      background: linear-gradient(136deg, #3280f8 0%, #6741e7 100%);
    }
    &.time {
      background: linear-gradient(136deg, #251cac 0%, #4623df 100%);
    }
    &.arch {
      background: linear-gradient(136deg, #189bfe 0%, #65d5ff 100%);
    }
  }
}
</style>
